export default __webpack_public_path__ + "static/media/joy_say_can_connect.bc22422e.svg";